(function () {
    'use strict';

    angular.module("imApp").factory("shiftService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 517,
                    parameters: parms || {}
                });
            },
            listWeekDays: function (parms) {
                return $ihttp.post({
                    method: 521,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 518,
                    parameters: edit
                });
            },
            deleteItem: function (edit) {
                return $ihttp.post({
                    method: 519,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
